import { getPlanCodesForCompany, getPlanDetails } from '../planDetails';

/**
 * Flow-specific mock data for Mikasa + Recurly.
 *
 * Adding a new signup flow:
 * 1. Wire the plan as usual (planDetails, planService, App route).
 * 2. Company / plan / office mocks are generated from that wiring.
 * 3. Optional: add a COMPANY_FLOW_OVERRIDES entry for a branded name or offices.
 * 4. Optional: add a COUPONS entry if the flow ships a promo (see /signup/rewards).
 */

export const COUPONS = {
  'lo-rewards': { type: 'percent', rate: '1' },
  waive100: { type: 'amount', amount: { USD: 100 } },
  paidsocial20: { type: 'percent', rate: '0.2' },
  save20: { type: 'percent', rate: '0.2' },
  trial30: { type: 'free_trial', trial: { amount: 30, unit: 'day' } }
};

export const COMPANY_FLOW_OVERRIDES = {
  '218d90e3-3f41-4000-b6ae-467edfc4e929': {
    name: 'Fairway Independent Mortgage',
    offices: ['Denver HQ', 'Austin', 'Remote']
  },
  '9037c833-17c2-43fe-aec3-ae4c43cecf6c': {
    name: 'Edge Home Finance',
    offices: ['Phoenix HQ', 'Scottsdale']
  },
  '7c7eaa86-e792-469f-91ee-d9597719795c': {
    name: 'American Pacific Mortgage',
    offices: ['Branch 101', 'Branch 202']
  },
  'e0e2548b-4c93-4c33-a8ba-137e2e124d83': {
    name: 'Summit Lending',
    offices: ['Headquarters', 'West Region']
  },
  'f6730666-cd94-4e1a-b300-de1e370ba15d': {
    name: 'Newrez',
    offices: ['Corporate', 'Wholesale']
  }
};

const DEFAULT_SPONSOR = {
  firstName: 'Alex',
  lastName: 'Sponsor',
  photoUri: '',
  corporationName: 'Mock Lending Co',
  nmlsId: '1234567',
  freemiumAgents: 'enabled'
};

const companyNameFromPlans = (planCodes) => {
  const details = getPlanDetails(planCodes[0]);
  if (!details?.planName) return 'Mock Company';

  return details.planName
    .replace(/\s+(Preferred\s+)?(Broker\s+)?(IMB\s+)?(Lender\s+)?(Pro|Starter|Unlimited|Individual)$/i, '')
    .replace(/\s+for\s+.+$/i, '')
    .trim() || details.planName;
};

export const getCompanyFixture = (companyId) => {
  const planCodes = getPlanCodesForCompany(companyId);
  const override = COMPANY_FLOW_OVERRIDES[companyId];

  if (!planCodes && !override) {
    return {
      name: `New signup company ${companyId.slice(0, 8)}`,
      offices: ['Headquarters'],
      planCodes: [],
      unknown: true
    };
  }

  const codes = planCodes || [];
  const name = override?.name || companyNameFromPlans(codes);
  const offices = override?.offices || [`${name} HQ`, `${name} West`];

  return { name, offices, planCodes: codes, unknown: false };
};

export const getSponsorFixture = (sponsorId) => {
  const disableFreemium = String(sponsorId).toLowerCase().includes('nofreemium');
  return {
    ...DEFAULT_SPONSOR,
    freemiumAgents: disableFreemium ? 'disabled' : 'enabled'
  };
};

export const getCoupon = (code) => COUPONS[String(code).trim().toLowerCase()] || null;
